module.exports = __webpack_public_path__ + "static/media/Biotechnology.d1e257ac.png";